module.exports = __webpack_public_path__ + "static/media/freecodecamp-projects.b06983d4.png";